module.exports = __webpack_public_path__ + "img/bg_academic.397d0c34.jpg";